<template>

   <modal name="cloud"    
      @before-close="close"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    :width="'100%'"
    >
      <card>


       <div class="mb-4">
           <p-button
                  class="btn-sm mr-2"
          
                  round
                  @click.native.prevent="$modal.hide('cloud')"
                  ><span class="ti-arrow-left"> Назад</span> </p-button
                >
                <p-button
                  class="btn-sm"
                  type="info"
                  @click.native.prevent="addItem"
                  >Загрузить изображения</p-button
                >
    </div>


      <div class="mb-4">
                 <fg-input
            :type="`text`"
            :label="`Поисковый запрос`"
            v-model="query"
          ></fg-input>

              <p-button
                  class="btn-sm mr-2"
                      type="warning"
                  round
                  @click.native.prevent="init"
                  ><span class="ti-reload"> Найти</span> </p-button
                >
      </div>

    <ul class="cloud-image">
          <template v-for="(item,key) in items">
                <li :key="key">
                      <input class="checkbox" name="new_image" v-model="val" :value="item" type="checkbox"/>
                      <img :src="item" @error="errorLoad"/>
                </li>
          </template>
    </ul>

        <div class="mt-2">
           <p-button
                  class="btn-sm mr-2"
          
                  round
                  @click.native.prevent="$modal.hide('cloud')"
                  ><span class="ti-arrow-left"> Назад</span> </p-button
                >
                <p-button
                  class="btn-sm"
                  type="info"
                  @click.native.prevent="addItem"
                  >Добавить</p-button
                >
    </div>
    </card>
    </modal>
</template>
<script>
export default {
  props: {
    q: {
      type: String,
      default: ""
    },
    typeCloud: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
        items:[],
        val:[],
        query:''
    };
  },
  created(){
      this.query = this.q;
      setTimeout(()=>{
          this.init();
      },50);

  },
  methods: {

    close(){
      this.val=[];
      this.$emit('close',true);
    },
      errorLoad(e){
              e.target.src = require("@/assets/img/no-photo-available.png")
      },
      init(){
        this.items = [];
        this.$loading(true);
        const options = {
            method: 'POST',
            url: `https://api.shop.ucell.uz/temp/${this.typeCloud}.php`,
            data:{
              search: this.query
            },
            withCredentials:false
          };
          this.$http.request(options).then( (response) => {
            this.items = response.data;
          }).catch( (error)  => {

          }).finally(() => {
            this.$loading(false);
          });
      },
      addItem(){
         this.$emit('input',this.val);

      }
  }
};
</script>

<style lang="scss">
  .cloud-image {
    display:flex;
      flex-flow: row wrap;
    width:100%;
    border:0.5px solid #ebebeb;
    justify-content:center;
    & > li {

      height:200px;
      overflow:hidden;
      
      border:0.5px solid #ebebeb;
      


  
         @media (max-width:1024px){
            width: calc(100% / 4);
      }
      width: calc(100% / 6);

        @media (max-width:768px){
            width: calc(100% / 3);
      }

   
         @media (max-width:400px){
            width: calc(100% / 2);
      }

  
   

      position:relative;
      & > img {
        width:100%;
        height:100%;
        object-fit:contain;
         position: absolute;
    left: 50%;
    top: 50%;
    z-index:0;
    transform: translate(-50%,-50%);
      }

      & > .checkbox {
        position:absolute;
        top:10px;
        right:10px;
        z-index:2;
      }
    }
  }
</style>